import { render } from "./Funcionarios.vue?vue&type=template&id=22bcc0ea&scoped=true"
import script from "./Funcionarios.vue?vue&type=script&lang=js"
export * from "./Funcionarios.vue?vue&type=script&lang=js"

import "./Funcionarios.vue?vue&type=style&index=0&id=22bcc0ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22bcc0ea"]])

export default __exports__